
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/LeanProjectHandler/LeanProjectHandler.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./LeanProjectHandler.html');
        
        var script = require('./LeanProjectHandler.ts').default;
        module.exports = require('./LeanProjectHandler.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    